import { render, staticRenderFns } from "./MT5.vue?vue&type=template&id=61a87d2d&scoped=true"
import script from "./MT5.vue?vue&type=script&lang=js"
export * from "./MT5.vue?vue&type=script&lang=js"
import style0 from "./MT5.vue?vue&type=style&index=0&id=61a87d2d&prod&scoped=true&lang=css"
import style1 from "./MT5.vue?vue&type=style&index=1&id=61a87d2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a87d2d",
  null
  
)

export default component.exports